const css = `._7x6QHW__icon{display:block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"icon":"_7x6QHW__icon"};
